module.exports = __webpack_public_path__ + "media/add/off-80-image-c6198050.png";